import NsfResolutionInstructions from "./NsfResolutionInstructions";
const NSF_RESOLUTION_INSTRUCTIONS_PATH =
  "/nsf-resolution-instructions/:objectFlagId";
export {
  NSF_RESOLUTION_INSTRUCTIONS_PATH,
  NsfResolutionInstructions as NsfResolutionInstructions,
};
